import React from "react";

export default function SalaryStructureToolbar({
  search,
  setSearch,
  departmentFilter,
  setDepartmentFilter,
  statusFilter,
  setStatusFilter,
  onAdd,
  departments,
}) {
  return (
    <div className="finance-toolbar">

      <input
        type="text"
        placeholder="Search salary structure..."
        className="finance-search"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      <select
        className="finance-select"
        value={departmentFilter}
        onChange={(e) => setDepartmentFilter(e.target.value)}
      >
        <option value="All">All Departments</option>

        {departments.map((dept) => (
          <option key={dept} value={dept}>
            {dept}
          </option>
        ))}
      </select>

      <select
        className="finance-select"
        value={statusFilter}
        onChange={(e) => setStatusFilter(e.target.value)}
      >
        <option value="All">All Status</option>
        <option value="Active">Active</option>
        <option value="Inactive">Inactive</option>
      </select>

      <button
        className="finance-primary-btn"
        onClick={onAdd}
      >
        + Create Structure
      </button>

    </div>
  );
}
